import { createSelector } from 'reselect';
import { FONT_SETS } from 'ContentUtils/constants/Fonts';
export const getGoogleFonts = state => state.resources.googleFonts.fonts;
export const getGoogleFontsPagination = state => state.resources.googleFonts.googleFontsPagination;
export const getGoogleFontsFetchStatus = state => state.resources.googleFonts.googleFontsRequestStatus;
export const getCustomFontsByAsset = (state, props) => state.resources.googleFonts.customFontsByAsset[props.assetPath] || {};
export const getCustomFonts = state => state.resources.googleFonts.customFonts || {};
export const getSelectedCustomFonts = state => state.resources.googleFonts.selectedCustomFonts;
export const selectedGoogleFonts = state => state.resources.googleFonts.selectedFonts;
export const getCommonGoogleFontResults = state => state.resources.googleFonts.commonFonts;
export const getCommonGoogleFonts = createSelector([getCommonGoogleFontResults], fonts => {
  return fonts.reduce((hash, font) => {
    hash[font.family] = font;
    return hash;
  }, {});
});
export const getCommonFontsFetchStatus = state => state.resources.googleFonts.commonFontsRequestStatus;
export const getOptions = createSelector([getGoogleFonts], fonts => {
  if (!(fonts && Object.keys(fonts))) return [];
  return Object.keys(fonts).map(name => {
    const font = fonts[name];
    return {
      fontSet: FONT_SETS.GOOGLE,
      text: font.family,
      value: font.family
    };
  });
});
export const getCustomFontsByAssetOptions = createSelector([getCustomFontsByAsset], customFonts => {
  if (!(customFonts && Object.keys(customFonts))) return [];
  return Object.keys(customFonts).map(name => {
    const font = customFonts[name];
    return {
      fontSet: FONT_SETS.CUSTOM,
      text: font.family,
      value: font.family
    };
  });
});
export const getCustomFontsOptions = createSelector([getCustomFonts], customFonts => {
  if (!customFonts) return [];
  return Object.keys(customFonts).map(name => {
    const font = customFonts[name];
    return {
      fontSet: FONT_SETS.BRANDING,
      text: font.name,
      value: font.name
    };
  });
});
export const getCustomFontsByAssetFetchStatus = (state, props) => state.resources.googleFonts.customFontsByAssetRequestStatus[props.assetPath];
export const getCustomFontsFetchStatus = state => state.resources.googleFonts.customFontsRequestStatus;
export const getBrandFonts = state => state.resources.googleFonts.brandFonts;
export const getBrandFontsFetchStatus = state => state.resources.googleFonts.brandFontsRequestStatus;
export const getBrandFontOptions = createSelector([getBrandFonts], brandFonts => {
  // only include primary + body fonts int his section
  // filter out duplicate fonts
  const seenNames = new Set();
  return brandFonts === null || brandFonts === void 0 ? void 0 : brandFonts.reduce((acc, brandFont) => {
    const {
      fontSet,
      fontType,
      name,
      optionText
    } = brandFont;
    if ((fontType === 'PRIMARY' || fontType === 'SECONDARY') && !seenNames.has(name)) {
      seenNames.add(name);
      acc.push({
        fontSet,
        text: optionText || name,
        value: name
      });
    }
    return acc;
  }, []);
});